import Vue from 'vue';
import { Button, Select, Option, OptionGroup, Dialog, Form, FormItem, Input, Checkbox} from 'element-ui';

Vue.component(Button.name, Button);
Vue.component(Select.name, Select);
Vue.component(OptionGroup.name, OptionGroup);
Vue.component(Option.name, Option);
Vue.component(Dialog.name, Dialog);
Vue.component(Form.name, Form);
Vue.component(FormItem.name, FormItem);
Vue.component(Input.name, Input);
Vue.component(Checkbox.name, Checkbox);